import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { Breadcrumb, Tabs } from '../../../../components';
import Items from './Items';

class List extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // selectedTab: 0,
    };
  }

  changeSelectedTab = (/* { index } */) => {
    // this.setState({ selectedTab: index });
  };

  novo = () => {
    const { history } = this.props;
    history.push('/admin/usuario/0');
  };

  render() {
    const { match } = this.props;
    return (
      <div>
        <Breadcrumb
          title="Usuários"
          description="Gerencie os usuários e permissões."
          renderRight={(() => (
            <div className="breadcrumb-right-actions">
              <button
                type="button"
                className="bx--btn btn-secondary-color v-md-margin"
                onClick={this.novo}
              >
                Cadastrar
              </button>
            </div>
          ))()}
        />
        <section className="content-wrapper">
          <Tabs
            sections={[
              { title: 'Novos', path: `${match.url}/novos` },
              { title: 'Liberados', path: `${match.url}/liberados` },
              { title: 'Bloqueados', path: `${match.url}/bloqueados` },
              { title: 'Criativos', path: `${match.url}/criativos` },
            ]}
          />
          <Route
            path={`${match.url}/novos`}
            component={() => <Items {...this.props} defaultFilters="status=3" />}
          />
          <Route
            path={`${match.url}/liberados`}
            component={() => <Items {...this.props} defaultFilters="status=1" />}
          />
          <Route
            path={`${match.url}/bloqueados`}
            component={() => <Items {...this.props} defaultFilters="status=2" />}
          />
           <Route
            path={`${match.url}/criativos`}
            component={() => <Items {...this.props} defaultFilters="status=0" />}
          />
        </section>
      </div>
    );
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/screens/admin/Users/List/List.js